jQuery(document).ready(function ($) {


    // assign a unique ID to each scroll-to point
    $('.scroll-to').each(function (index,value) {
        if (typeof $(this).attr('id') == typeof undefined)
            $(this).attr('id', 'scroll-down'+index);
    });

    var mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    $('#scroll-icon').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $nextElem = updateScrollTarget();
        if (mediaQuery.matches) {
            if ($nextElem) {
                $('html,body').scrollTop($nextElem.offset().top);
            } else {
                $('html,body').scrollTop($(window).scrollTop() + $(window).innerHeight() * .9);
            }
        } else {
            if ($nextElem) {
                $('html, body').animate({
                    scrollTop: $nextElem.offset().top
                }, 250);
            } else {
                $('html, body').animate({
                    scrollTop: $(window).scrollTop() + $(window).innerHeight() * .9
                }, 500);
            }
        }
        updateScrollTarget();
    });
    updateScrollTarget();

    function updateScrollTarget()
    {
        // find the next .scroll-to point after the current scrolltop position
        var curPos = $(window).scrollTop();
        var $nextElem = null;
        $('.scroll-to').each(function () {
            var tolerance = $(window).innerHeight() * .6;
            if ($(this).parents('d-none').length && !$(this).parents('d-none').first().is(':visible')) {
                // if any direct ancestor of this element has d-none, check if the parent is visible
                // if it's not visible, this will skip us to the next element:
                return true;
            }
            if ($(this).hasClass('scroll-to-force')) {
                tolerance = 200;
            }
            if ($(this).offset().top > curPos + tolerance) {
                $nextElem = $(this);
                return false;
            }
        });

        if ($nextElem) {
            $('#scroll-icon').attr('href', '#'+$nextElem.attr('id'));
        }
        return $nextElem;
    }


// Hide and show scroll button when close to the bottom of the page

    var ctrl = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: "#footer",
        triggerHook: 0.9, // show, when scrolled 10% into view
        duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
        offset: -150 // move trigger to center of element
    })
    .setClassToggle(".scroll-icon", "hide-icon") // add class to reveal
    .addTo(ctrl);

});
